export default "__VITE_ASSET__15hum0ky__"